var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-alert',_vm._b({attrs:{"variant":_vm.galaxyKwdToBootstrap,"show":_vm.showP}},'b-alert',_vm.$props,false),[_vm._t("default",[_vm._v("\n        "+_vm._s(_vm.message)+"\n    ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }